export default __webpack_public_path__ + "chromis_stickup.06ef786a.png";